import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import DetailsPage from '../components/DetailsPage';
// import './BhavanDetails.css';

function BhavanDetails() {
  const { bhavanId, bhavanName } = useParams();
  const [bhavanDetails, setBhavanDetails] = useState(null);
  const [totalAmount, setTotalAmount] = useState('0.00');
  const [totalDiscount, setTotalDiscount] = useState('0.00');
  const [isLoading, setIsLoading] = useState(true);

  // Helper function to safely parse amount
  const parseAmount = (amount) => {
    if (!amount) return 0;
    // Remove any commas and convert to number
    return parseFloat(amount.toString().replace(/,/g, ''));
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append('bhaban_id', bhavanId);

    const fetchBhavanData = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/BhabanReports`,{
          method: 'POST',
          body: formData
        });
        const data = await response.json();
        setBhavanDetails(data?.report_list);
        
        // Calculate initial totals from the data
        if (data?.report_list) {
          const initialTotal = data.report_list.reduce((sum, row) => sum + parseAmount(row.amount), 0);
          const initialDiscount = data.report_list.reduce((sum, row) => sum + parseAmount(row.discount_amount), 0);
          setTotalAmount(initialTotal.toFixed(2));
          setTotalDiscount(initialDiscount.toFixed(2));
        }
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching bhavan data:', error);
        setIsLoading(false);
      }
    };
    fetchBhavanData();
  }, [bhavanId]);

  const columns = [
    { field: 'booking_id', header: 'Booking ID' },
    { field: 'customer_name', header: 'Customer Name' },
    { field: 'booking_date', header: 'Booking Date' },
    { field: 'checkin_date', header: 'Check-in Date' },
    { field: 'checkin_out', header: 'Check-out Date' },
    { field: 'amount', header: 'Amount' },
    { field: 'discount_amount', header: 'Discount' }
  ];

  const handleRowClick = (row) => {
    console.log('Row clicked:', row);
  };

  const handleDateFilterChange = (startDate, endDate, filteredData) => {
    // Calculate total amount and discount for filtered data
    const newTotalAmount = filteredData.reduce((sum, row) => sum + parseAmount(row.amount), 0).toFixed(2);
    const newTotalDiscount = filteredData.reduce((sum, row) => sum + parseAmount(row.discount_amount), 0).toFixed(2);
    
    setTotalAmount(newTotalAmount);
    setTotalDiscount(newTotalDiscount);
  };

  return (
    <div className="bhavan-details-container">
      <DetailsPage
        title={`${bhavanName} Booking Details`}
        backPath="/bhavan"
        columns={columns}
        data={bhavanDetails || []}
        onRowClick={handleRowClick}
        totalAmount={totalAmount}
        totalDiscount={totalDiscount}
        isLoading={isLoading}
        onDateFilterChange={handleDateFilterChange}
        dateField="booking_date"
      />
    </div>
  );
}

export default BhavanDetails; 